<template>
    <div>

    <div id="0">
    <Home/>
    </div>
    <div  v-on:mouseover="scrollAbout" style="margin-bottom:8%;"> 
    <About/>
    </div>
    <div   v-on:mouseover="scrollTeam">
    <Team/>
    </div>
    <div   v-on:mouseover="scrollService" >
      <Service/>
    </div>
    <div  v-on:mouseover="scrollSlide">
    <Slides/>
    </div>
    <Foot/>
    </div>

</template>


<script>


import Slides from './Slides.vue';
import Foot from './Foot.vue';
import Home from './Home.vue';
import About from './About.vue';
import Team from './Team.vue';
import Service from './Service.vue';

export default {
  name: "HomePage",
   components: {
   
   Slides,
    Foot,
    Home,
    About,
    Team,
    Service,
 
  },
   data() {
    return {
      hover: false,
      urlAbout:'/AboutPage#1',
      urlTeam:'/TeamPage#2',
      urlService:'/ServicePage#3',
      urlSlide:'/SlidesPage#4',
     
    }
   },
   
 
    methods: {
   
    scrollAbout: function()
    {
     
    history.pushState({}, null,  this.urlAbout);
    window.location.href= '/AboutPage#1'
       
  },
  scrollTeam: function()
    {
     
    history.pushState({}, null,  this.urlTeam);
    window.location.href= '/TeamPage#2'
  },
  scrollService: function()
    {
     
    history.pushState({}, null,  this.urlService);
    window.location.href= '/ServicePage#3'
       
  },
  scrollSlide: function()
    {
     
    history.pushState({}, null,  this.urlSlide);
    window.location.href= '/SlidesPage#4'
       
  }
    
   }
};
</script>
<style scoped>

</style>

